import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import { API_URL } from "@/utils/apiConfig";
const API = API_URL;

export default function CollabJoinPage() {
  const { collabId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const join = async () => {
      try {
        const { data } = await axios.get(`${API}/collab/${collabId}`);
        navigate(`/editor/${data.diagram_id}`, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Lien de collaboration invalide");
      }
    };
    join();
  }, [collabId, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-sm text-gray-500">{error}</p>
          <button onClick={() => navigate("/login")} className="mt-4 text-indigo-600 text-sm font-semibold hover:underline">
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-sm text-gray-400 animate-pulse">Connexion a la session collaborative...</p>
    </div>
  );
}
